var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { IdLang } from "../../utils/i18n/IdLang";
import { utilLoca } from "../../utils/i18n/utilLoca";
import { ContextLoca } from "./ContextLoca";
var LocaManager = /** @class */ (function (_super) {
    __extends(LocaManager, _super);
    function LocaManager() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            lang: IdLang.None,
        };
        _this.onLangChange = function (lang) {
            _this.setState({
                lang: lang,
            });
        };
        return _this;
    }
    LocaManager.prototype.componentDidMount = function () {
        this.locaSub$ = utilLoca.langChange$.subscribe(this.onLangChange);
    };
    LocaManager.prototype.componentWillUnmount = function () {
        this.locaSub$.unsubscribe();
    };
    LocaManager.prototype.render = function () {
        var lang = this.state.lang;
        return React.createElement(ContextLoca.Provider, { value: lang }, this.props.children);
    };
    return LocaManager;
}(React.PureComponent));
export { LocaManager };



//////////////////
// WEBPACK FOOTER
// ./src/features/loca/LocaManager.tsx
// module id = 1119
// module chunks = 3